export const stringToBoolean = ( string: string ): boolean =>
  string === 'false' || string === 'undefined' || string === 'null' || string === '0' ?
    false : !!string;

export const booleanToString = ( bool: boolean ): string => bool ? 'true' : 'false';
